import { render, staticRenderFns } from "./DiscountCodeCreateForm.vue?vue&type=template&id=6ca4b704&"
import script from "./DiscountCodeCreateForm.vue?vue&type=script&lang=js&"
export * from "./DiscountCodeCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ca4b704')) {
      api.createRecord('6ca4b704', component.options)
    } else {
      api.reload('6ca4b704', component.options)
    }
    module.hot.accept("./DiscountCodeCreateForm.vue?vue&type=template&id=6ca4b704&", function () {
      api.rerender('6ca4b704', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DiscountCodeCreateForm.vue"
export default component.exports